import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import router from './router'
import storage from 'store'
import { getToken } from '@/api/auth'
import { isWapClient, shouldShowMobileUnavailablePage } from '@/utils/platform'
import 'ant-design-vue/dist/antd.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.use(Antd);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// http://momentjs.cn/docs/#/use-it/
import moment from 'moment'
moment.locale('zh-cn')

const allowList = ['login', 'fileshared'] // no redirect allowList
const loginRoutePath = '/login'

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  const sn = to.query.sn
  const apk = to.query.apk

  if (sn) {
    storage.set('sn', sn)
  }
  if (apk) {
    storage.set('CurrentDir', '/' + apk + '/')
  }

  const token = getToken()
  if (token) {
    next()
  } else {
    if (allowList.includes(to.name)) {
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
    }
  }
})

const showMobileUnavailablePage = shouldShowMobileUnavailablePage()
const RootApp = showMobileUnavailablePage
  ? () => import(/* webpackChunkName: "mobile-unavailable" */ './views/MobileUnavailable.vue')
  : isWapClient()
    ? () => import(/* webpackChunkName: "wap-app" */ './wap/App.vue')
    : App

const appOptions = {
  render: h => h(RootApp)
}

if (!showMobileUnavailablePage) {
  appOptions.router = router
}

new Vue(appOptions).$mount('#app')
